import styled from 'styled-components';
import { token } from '@bynder/design-system';

export const Content = styled.div`
    display: flex;
    height: auto;
    padding-bottom: ${token.spacing4};
`;

export const Right = styled.div`
    display: flex;
    margin-left: auto;
    justify-content: flex-end;
`;

export const DropdownItemSWrapper = styled.div`
    max-height: 270px;
    overflow-y: auto;
`;
